import React from 'react';
import { LendingDiv } from '../component/lending/LendingDiv';

export const LendingPage = () => <LendingDiv />;
